module.exports = __webpack_public_path__ + "static/media/img-5.fc68d159.png";